
import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { useAppDispatch } from "../../../State/Store";
import { addNewAddress, fetchAllAddress } from "../../../State/customer/AddressSlice";

import { useNavigate } from "react-router-dom";
import { Box, Grid2, TextField, Button } from "@mui/material";
import { Address } from "../../../types/userType";

//
type Props ={
  
  setSuccessMessage: React.Dispatch<React.SetStateAction<boolean>>;
  
}
export const AddressFormSchema = Yup.object().shape({
  streetName: Yup.string().required("Street Name is required"),
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{9,15}$/, "Mobile number is not valid"),
  postalCode: Yup.string()
    .required("Postal Code is required")
    .matches(/^\d{5}$/, "Postal Code is not valid"),
  region: Yup.string().required("Region is required"),
  city: Yup.string().required("City is required"),
  country: Yup.string().required("Country is required"),
});
export const AddressForm:React.FC<Props> = ({setSuccessMessage}) => {
  const dispatch = useAppDispatch();
  
  
 
  const formik = useFormik({
    initialValues: {
      city: "",
      country: "",
      mobile: "",
      postalCode: "",
      region: "",
      streetName: ""

    },
    validationSchema: AddressFormSchema,
    onSubmit: async (values: Address) => {
      //submit form
   
      await dispatch(addNewAddress(values)).unwrap();

      // await dispatch(fetchAllAddress())
      setSuccessMessage(true)
     
      
    },
  });

  return (
    <Box sx={{ max: "auto" }}>
      <p className="text-xl font-bold text-center pb-5">Contact Details</p>
     
      <form onSubmit={formik.handleSubmit}>
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              name="streetName"
              label="Street Name"
              value={formik.values.streetName}
              onChange={formik.handleChange}
              error={
                formik.touched.streetName && Boolean(formik.errors.streetName)
              }
              helperText={formik.touched.streetName && formik.errors.streetName}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <TextField
              fullWidth
              name="mobile"
              label="Mobile"
              value={formik.values.mobile}
              onChange={formik.handleChange}
              error={formik.touched.mobile && Boolean(formik.errors.mobile)}
              helperText={formik.touched.mobile && formik.errors.mobile}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <TextField
              fullWidth
              name="postalCode"
              label="Postal Code"
              value={formik.values.postalCode}
              onChange={formik.handleChange}
              error={
                formik.touched.postalCode && Boolean(formik.errors.postalCode)
              }
              helperText={formik.touched.postalCode && formik.errors.postalCode}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <TextField
              fullWidth
              name="city"
              label="City"
              value={formik.values.city}
              onChange={formik.handleChange}
              error={formik.touched.city && Boolean(formik.errors.city)}
              helperText={formik.touched.city && formik.errors.city}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <TextField
              fullWidth
              name="region"
              label="Region"
              value={formik.values.region}
              onChange={formik.handleChange}
              error={formik.touched.region && Boolean(formik.errors.region)}
              helperText={formik.touched.region && formik.errors.region}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              name="country"
              label="Country"
              value={formik.values.country}
              onChange={formik.handleChange}
              error={formik.touched.country && Boolean(formik.errors.country)}
              helperText={formik.touched.country && formik.errors.country}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            {/* provide fullWidth for button even if provide the parent size is 12 */}
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ py: "14px" }}
            >
              Add Address
            </Button>
          </Grid2>
        </Grid2>
      </form>
    </Box>
  );
};
